import React from "react";

function SvgIcMapPoi058(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M11.533 6a.5.5 0 01.5.5V7h3v2h-3v3l5.5 11H12l-.957-9L8 23H5.54l.307-.615-.472-1.803a.5.5 0 01.968-.254l.183.698 4.506-9.025V6.5a.5.5 0 01.5-.5zM20 11l5.316 10.63.34-1.302a.5.5 0 01.968.254l-.63 2.405L26 23h-6l.634-2.418a.499.499 0 10-.967-.254l-.344 1.317L14 11h6z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi058;
